export default "__VITE_ASSET__jppH9ILg__"